import { getUserLanguageFromLocalStorage } from '@experiences/locales';

export async function getHeaders(token: string, headers?: Record<string, string>) {
    const reqHeaders: Record<string, string> = {
        'Content-Type': 'application/json; charset=UTF-8',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'x-uipath-localization': getUserLanguageFromLocalStorage(),
    };

    if (headers?.extendRequestHeaders === 'true') {
        delete headers.extendRequestHeaders;
        headers = {
            ...reqHeaders,
            ...headers,
        };
    }

    const includeAuthorization = headers?.IncludeAuthorization !== 'false';
    if (headers && includeAuthorization && !headers.Authorization) {
        headers.Authorization = `Bearer ${token}`;
    }
    delete headers?.IncludeAuthorization;

    return headers ?? reqHeaders;
}
